import ApiService from './api.service'

const GameService = {
  index (venue) {
    return ApiService.get('api/scorekeeper/games', {
      params: {
        venue
      }
    })
  },
  gamesVenues () {
    return ApiService.get('api/scorekeeper/games-venues')
  },
  showGallery (scheduleUuid, gameUuid) {
    return ApiService.get(`api/v1/admin/schedules/${scheduleUuid}/games/${gameUuid}/gallery`)
  },
  live () {
    return ApiService.get('api/v1/game/live')
  },
  logs () {
    return ApiService.get('api/v1/game/live/logs')
  },
  liveSubstitutions () {
    return ApiService.get('api/v1/game/live/substitutions')
  },
  goLive (data) {
    return ApiService.postWithoutLoading('api/v1/game/live', data)
  },
  updateLivePlayer (playerUuid, data) {
    return ApiService.putWithoutLoading(`api/v1/game/live/players/${playerUuid}`, data)
  },
  removableLivePlayers () {
    return ApiService.get('api/v1/game/live/players/removable')
  },
  removeLivePlayer (playerUuid) {
    return ApiService.deleteWithoutLoading(`api/v1/game/live/players/${playerUuid}`)
  },
  addLivePlayer (data) {
    return ApiService.postWithoutLoading('api/v1/game/live/players', data)
  },
  backToLive (data) {
    return ApiService.put('api/v1/game/back-to-live', data)
  },
  preGame () {
    return ApiService.get('api/v1/game/pre_game')
  },
  status () {
    return ApiService.get('api/v1/game/status')
  },
  enterTheGame (code) {
    return ApiService.get('api/v1/game/status', {
      headers: {
        code: code
      }
    })
  },
  embedVideo (data) {
    return ApiService.postWithoutLoading('api/v1/game/live/embedVideo', data)
  },
  createYtEvent () {
    return ApiService.postWithoutLoading('api/v1/game/live/yt-event', {})
  },
  deleteYtEvent () {
    return ApiService.deleteWithoutLoading('api/v1/game/live/yt-event')
  },
  gameLog (data) {
    return ApiService.postWithoutLoading('api/v1/game/live/gamelog', data)
  },
  deleteLog (uuid) {
    return ApiService.deleteWithoutLoading('api/v1/game/live/gamelog/' + uuid)
  },
  deleteLogWithoutAsking (uuid) {
    return ApiService.deleteWithoutAsking('api/v1/game/live/gamelog/' + uuid)
  },
  setPeriod (data) {
    return ApiService.put('api/v1/game/live/period', data)
  },
  endGame () {
    return ApiService.postWithoutLoading('api/v1/game/live/end')
  },
  archive (data) {
    return ApiService.postWithoutLoading('api/v1/game/live/archive', data)
  },
  getArchive () {
    return ApiService.get('api/v1/game/live/getarchive')
  },
  getPlayersOfTheGame (homeTeamScoreTotal, awayTeamScoreTotal) {
    return ApiService.get(`api/v1/game/live/players-of-the-game?homeTeamScoreTotal=${homeTeamScoreTotal}&awayTeamScoreTotal=${awayTeamScoreTotal}`)
  },
  stopwatch () {
    return ApiService.get('api/v1/game/stopwatch')
  },
  substitution (data) {
    return ApiService.postWithoutLoading('api/v1/game/live/substitution', data)
  },
  deleteSubstitution (uuid) {
    return ApiService.delete('api/v1/game/live/substitution/' + uuid)
  },
  showSubstitution (uuid) {
    return ApiService.get('api/v1/game/live/substitution/' + uuid)
  },
  updateSubstitution (uuid, data) {
    return ApiService.putWithoutLoading('api/v1/game/live/substitution/' + uuid, data)
  }
}

export default GameService
